import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../../../@base/base.dto';
import { StripeSubscriptionEventId } from '../../../types';

export class StripeSubscriptionEventDto extends BaseDto<StripeSubscriptionEventId> {
  @IsString()
  @IsNotEmpty()
  eventId!: string;

  @IsString()
  @IsNotEmpty()
  type!: string;

  @IsNotEmpty()
  payload!: Record<string, unknown>;

  @IsBoolean()
  @IsNotEmpty()
  processed!: boolean;

  @IsDate()
  @Type(() => Date)
  @IsOptional()
  processedAt?: Date;

  @IsString()
  @IsOptional()
  error?: string;
}
